import { createColumnVisibilityStore } from '@/components/zthd/data-table'
import { createCountryStore } from '@/components/DropdownCountry'

export const storeName = 'roi-apple-regression'
export const useCountry = createCountryStore('US', storeName)
export const useColumnVisibilityStore = createColumnVisibilityStore(
  {},
  storeName,
)
